// "Mac mode": the page is running inside the WaageWu Mac app's hub
// window (a WKWebView). The app's injected script sets
// window.__WAAGEWU_MAC__ before any page script runs; it is read once,
// at startup. In Mac mode <html> gets class `mac-app` (main.tsx, and the
// pre-paint script in index.html), which hides the rail brand and the
// theme toggles (app.css), and the theme follows the system appearance
// whatever a browser session stored (lib/theme.ts). Browsers never see
// any of it.

declare global {
  interface Window {
    __WAAGEWU_MAC__?: unknown;
  }
}

export const MAC_APP: boolean = typeof window !== 'undefined' && Boolean(window.__WAAGEWU_MAC__);
